var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128,254.7A126.7,126.7,0,1,1,254.7,128,126.85,126.85,0,0,1,128,254.7Zm0-237.78A111.08,111.08,0,1,0,239.08,128,111.21,111.21,0,0,0,128,16.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.25,196.26c-26.63,0-44.86-11.21-54.21-33.32a91.56,91.56,0,0,1-4.69-15.46l-.22-1H60.59L63,134.93h9.41l-.07-1.37c-.13-2.2-.19-4.53-.19-6.93,0-.82,0-1.66,0-2.51l0-1.35H60.59L63,111.27H73.32l.22-1C77.31,91.47,86.88,77.79,102,69.57a65,65,0,0,1,30.83-7.8h.6c10.89,0,20.18,2.39,27.62,7.09l-3.46,16.08a38,38,0,0,0-24.34-8.83h-.18c-9.94,0-18.41,2.44-25.19,7.25a41.44,41.44,0,0,0-11,12.15,40.08,40.08,0,0,0-5.71,14.17l-.31,1.55h60.76l-2.32,11.5H89.57l0,1.25c0,.87,0,1.71,0,2.52,0,3.54,0,5.8,0,7.12l0,1.27h57.17l-2.37,11.51h-53l.32,1.56c2.63,12.9,8.62,22.23,17.81,27.73a42.59,42.59,0,0,0,22.1,6.17h.16c10.87,0,19.56-2.85,25.84-8.46v17.78a57.41,57.41,0,0,1-23.69,5.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoin);
export default __webpack_public_path__ + "static/media/icon-coin.698b4da0.svg";
export { ForwardRef as ReactComponent };